import { SurfaceNodeUnion } from 'graphql/types';
import useFetchSurfaceNodesFromCache from 'components/canvas/hooks/use-fetch-surface-nodes-from-cache';
import useCurrentSurface from 'routes/surface/hooks/use-current-surface';

export function useSurfaceNodesFromCache(surface?: string): SurfaceNodeUnion[] {
  const currentSurface = useCurrentSurface();

  const fetchSurfaceNodesFromCache = useFetchSurfaceNodesFromCache(
    surface ?? currentSurface?.id,
  );

  return fetchSurfaceNodesFromCache();
}

export default useSurfaceNodesFromCache;
